function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22 11c0 6.075-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0s11 4.925 11 11zm-10.132 1.684v.785c.001.654.002 1.309-.002 1.962a.85.85 0 01-.752.851.853.853 0 01-.96-.858v-.002c0-1.838-.002-3.677 0-5.515 0-.384.23-.701.577-.82a.853.853 0 01.959.289c.132.17.18.366.18.581-.002.66-.002 1.322-.002 1.982v.745zm-.87-4.695a1.165 1.165 0 001.17-1.148 1.153 1.153 0 00-1.144-1.17 1.153 1.153 0 00-1.17 1.144 1.166 1.166 0 001.144 1.174z",
  fill: "#fff"
});

function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none"
  }, props), _ref);
}

export default SvgInfo;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/info.svg
// module id = 1289
// module chunks = 10